const CONSENT_COOKIE_NAME = 'eplotera_hosting_analytics_consent';
const CONSENT_CHANGED_EVENT = 'eplotera:hosting-cookie-consent';
const CONSENT_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export type CookieConsentChoice = 'accepted' | 'declined';

function isCookieConsentChoice(value: string | undefined): value is CookieConsentChoice {
  return value === 'accepted' || value === 'declined';
}

function getCookieDomain(): string | null {
  const hostname = window.location.hostname.toLowerCase();
  return hostname === 'eplotera.com' || hostname.endsWith('.eplotera.com')
    ? '.eplotera.com'
    : null;
}

export function readCookieConsent(): CookieConsentChoice | null {
  if (typeof document === 'undefined') return null;

  const consentCookie = document.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(`${CONSENT_COOKIE_NAME}=`));

  if (!consentCookie) return null;
  const value = consentCookie.slice(CONSENT_COOKIE_NAME.length + 1);
  return isCookieConsentChoice(value) ? value : null;
}

export function subscribeToCookieConsent(onStoreChange: () => void): () => void {
  window.addEventListener(CONSENT_CHANGED_EVENT, onStoreChange);
  return () => window.removeEventListener(CONSENT_CHANGED_EVENT, onStoreChange);
}

export function saveCookieConsent(choice: CookieConsentChoice): void {
  const attributes = [
    `${CONSENT_COOKIE_NAME}=${choice}`,
    `Max-Age=${CONSENT_MAX_AGE_SECONDS}`,
    'Path=/',
    'SameSite=Lax',
  ];
  const domain = getCookieDomain();
  if (domain) attributes.push(`Domain=${domain}`);
  if (window.location.protocol === 'https:') attributes.push('Secure');

  document.cookie = attributes.join('; ');
  window.dispatchEvent(new CustomEvent<CookieConsentChoice>(CONSENT_CHANGED_EVENT, { detail: choice }));
}
